import type { ProductFormProps } from "../../types";
import { EditImageModal } from "../edit-image-modal";
import { ProductForm } from "../product-form";

type EditProductFormProps = ProductFormProps;

export const EditProductForm = ({
  formMethods,
  productCategory
}: EditProductFormProps) => {
  return (
    <>
      <EditImageModal formMethods={formMethods} />
      <ProductForm
        formMethods={formMethods}
        productCategory={productCategory ?? "software"}
      />
    </>
  );
};
